import { UPDATES_NODE_TYPES, UPDATE_IMPACT } from '@/common/constants/updates.constants';
import semver from 'semver';

function getNodeType(isPrimary, isManagementNode) {
  if (isPrimary) {
    return UPDATES_NODE_TYPES.PRIMARY_NODE;
  } else if (isManagementNode) {
    return UPDATES_NODE_TYPES.MANAGEMENT_NODE;
  }

  return UPDATES_NODE_TYPES.CLUSTER_NODE;
}

export function getNodeImpact(downloadedReleaseInfo) {
  if (downloadedReleaseInfo?.reboot_required) {
    return UPDATE_IMPACT.REBOOT;
  }
  if (downloadedReleaseInfo?.maintenance && Object.values(downloadedReleaseInfo?.maintenance).some(Boolean)) {
    return UPDATE_IMPACT.MAINTENANCE;
  }
  return UPDATE_IMPACT.NONE;
}

export default (node) => {
  const {
    available_storage_release: availableReleases,
    current_storage_release: currentRelease,
    downloaded_storage_release: downloadedRelease,
    host,
    id,
    is_in_ha: isManagementNode,
    is_primary: isPrimary,
    orig_hostname: hostName,
    status,
  } = node;

  const { version, release } = node.downloaded_storage_release || {};
  const downloadedReleaseInfo = node.available_storage_release.find(r => r.version === version && r.release === release);
  const impact = getNodeImpact(downloadedReleaseInfo);

  return ({
    id,
    host,
    hostName,
    name: hostName,
    status,
    availableReleases,
    currentRelease,
    downloadedRelease,
    downloadedReleaseInfo,
    isMajorUpdate: currentRelease?.version && downloadedRelease?.version && semver.diff(currentRelease.version, downloadedRelease.version) === 'major',
    availableMajorVersion: downloadedRelease?.version ? semver.major(downloadedRelease.version) : undefined,
    rebootRequired: impact === UPDATE_IMPACT.REBOOT,
    maintenanceRequired: impact === UPDATE_IMPACT.MAINTENANCE || impact === UPDATE_IMPACT.REBOOT,
    updateImpact: impact,
    type: getNodeType(isPrimary, isManagementNode)
  });
};
